<template>
  <div>
    <v-row no-gutters class="d-none d-md-flex">
      <v-col cols="10">
        <v-row>
          <v-col cols="2">
            <autocomplete-teacher
              v-model="name"
              item-text=""
              item-value=""
              label="Họ tên"
              filled
              clearable
              full-width
              single-line
              dense
              hide-details="auto"
            />
          </v-col>

          <v-col cols="2">
            <v-select
              single-line
              hide-details="auto"
              filled
              ref="status"
              v-model="status"
              label="Trạng thái"
              dense
              :items="getTeacherStatus"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-select
              single-line
              hide-details="auto"
              filled
              ref="gender"
              v-model="gender"
              label="Giới tính"
              required
              dense
              :items="genderOptions"
              item-text="text"
              item-value="value"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-select
              item-text="text"
              item-value="value"
              single-line
              hide-details="auto"
              filled
              ref="month"
              v-model="month"
              label="Tháng sinh"
              dense
              :items="getMonths"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="2">
            <autocomplete-major
              hide-details="auto"
              v-model="majors"
              filled
              dense
              label="Chuyên Ngành"
              required
              single-line
              multiple
            ></autocomplete-major>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="2" class="d-flex justify-end">
        <v-btn dark class="" color="#FFB300" depressed @click="onFilterChanged">
          <v-icon class="" left>mdi-filter-outline</v-icon>Lọc
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <div class="d-flex d-md-none justify-end">
      <v-btn icon @click="filterState = !filterState">
        <v-icon right>mdi-filter</v-icon>
      </v-btn>

      <teacher-filter-dialog @onFilterChanged="onFilterDialogChange" :state="filterState" />
    </div>
  </div>
</template>

<script>
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher'
import AutocompleteMajor from '@/components/basic/input/AutocompleteMajor.vue'
import TeacherFilterDialog from '@/modules/teacher/TeacherFilterDialog'
import { genderOptions, getMonths, getTeacherStatus } from '../../helpers'

export default {
  components: {
    AutocompleteTeacher,
    TeacherFilterDialog,
    AutocompleteMajor
  },
  computed: {
    genderOptions,
    getMonths,
    getTeacherStatus() {
      return getTeacherStatus(true)
    }
  },

  data: () => ({
    query: '',
    dialog: false,
    name: '',
    filterState: false,
    gender: '',
    month: '',
    status: 'active'
  }),
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        ...(this.name && { id: this.name }),
        ...(this.major && { majors: this.majors }),
        ...(this.gender && { gender: this.gender }),
        ...(this.status && { status: this.status === 'all' ? '' : this.status }),
        ...(this.month && { month: this.month })
      })
    },
    onFilterDialogChange(id) {
      this.$emit('onFilterChanged', id)
    }
  }
}
</script>
